import {
  DefaultPage,
  EditProjectConstant,
  CssCodeEditor,
  JsEditor,
  ActivityLogs,
  PublishTracklogs,
  Resources,
  PageJsUpdate,
  ListCollectionSnapshot,
  GlobalFonts,
  GlobalTheme,
  OverwriteDefaultUi,
  ProfilerTab,
  RobotsTxt,
  EnvironmentSetting,
  PwaConfiguration,
  CollectionDevApi,
  EncryptionSection,
  LocalizationSection,
  AppConfiguration,
  CreateProjectVersion,
  CustomCssTab,
  CustomJsTab,
  ListSnippetSnapshots,
  AiModelSection,
  LoaderScreen,
  FigmaSection,
  PHIAuditTab,
} from './';
import SitemapXml from './SitemapXml';
import PageSettingsForm from './PageSettingsForm';
import ShowDifferentLoader from './ShowDifferentLoader';
import NotificationSetting from './notification-setting/NotificationSetting';
import ListPageSnapshots from './ListPageSnapshots';
export default {
  path: 'app-setting/:version/v',
  name: 'App setting',
  childRoutes: [
    { path: ':projectId', name: 'Default page', component: DefaultPage, isPrivate: true },

    {
      path: ':projectId/setting/devKey',
      name: 'CollectionDevApi',
      component: CollectionDevApi,
      isPrivate: true,
    },

    {
      path: ':projectId/:constantId',
      name: 'Edit project constant',
      component: EditProjectConstant,
      isPrivate: true,
    },

    {
      path: ':projectId/setting/notificationSetting',
      name: 'NotificationSetting',
      component: NotificationSetting,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/environment',
      name: 'EnvironmentSetting',
      component: EnvironmentSetting,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/robots',
      name: 'RobotsTxt',
      component: RobotsTxt,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/loadingIcon',
      name: 'ShowDifferentLoader',
      component: ShowDifferentLoader,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/pageSetting',
      name: 'Page settings form',
      component: PageSettingsForm,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/appConstant',
      name: 'Default page',
      component: DefaultPage,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/pageSnapshot',
      name: 'ListPageSnapshots',
      component: ListPageSnapshots,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/snippetShapshot',
      name: 'ListSnippetSnapshots',
      component: ListSnippetSnapshots,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/customCSSeditor',
      name: 'Css code editor',
      component: CssCodeEditor,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/jseditor',
      name: 'Js editor',
      component: JsEditor,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/system-activity',
      name: 'Activity logs',
      component: ActivityLogs,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/version',
      name: 'CreateProjectVersion',
      component: CreateProjectVersion,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/publish-activity',
      name: 'Publish tracklogs',
      component: PublishTracklogs,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/resources',
      name: 'Resources',
      component: Resources,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/page-js/:pageId',
      name: 'Page js update',
      component: PageJsUpdate,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/collectionSnapshot',
      name: 'List collection snapshot',
      component: ListCollectionSnapshot,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/customFonts',
      component: GlobalFonts,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/sitemapXml',
      name: 'SitemapXml',
      component: SitemapXml,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/globalTheme',
      name: 'Global theme',
      component: GlobalTheme,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/typographyColours',
      name: 'Overwrite default ui',
      component: OverwriteDefaultUi,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/profiler-section',
      name: 'Profiler tab',
      component: ProfilerTab,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/pwa-config',
      name: 'Pwa configuration',
      component: PwaConfiguration,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/encryption-section',
      name: 'Encryption section',
      component: EncryptionSection,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/localization-section',
      name: 'Localization section',
      component: LocalizationSection,
      isPrivate: true,
    },

    {
      path: ':projectId/setting/app-config',
      name: 'App configuration',
      component: AppConfiguration,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/custom-css',
      name: 'Custom css tab',
      component: CustomCssTab,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/custom-js',
      name: 'Custom js tab',
      component: CustomJsTab,
      isPrivate: true,
    },

    {
      path: ':projectId/setting/aiModelConfig-section',
      name: 'Ai model section',
      component: AiModelSection,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/loader-screen',
      name: 'Loader screen',
      component: LoaderScreen,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/figmaConfig-section',
      name: 'Figma section',
      component: FigmaSection,
      isPrivate: true,
    },
    {
      path: ':projectId/setting/phi-audit',
      name: 'PHI Audit',
      component: PHIAuditTab,
      isPrivate: true,
    },
  ],
};
